import { Link } from 'react-router-dom';

export interface RelatedArticle {
  slug: string;
  title: string;
  category: string;
}

interface RelatedArticlesProps {
  articles: RelatedArticle[];
}

export default function RelatedArticles({ articles }: RelatedArticlesProps) {
  return (
    <div className="mt-12 pt-10 border-t border-white/10">
      <h2 className="text-white text-xl font-black tracking-wide mb-6 uppercase">
        Related Articles
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {articles.map((article) => (
          <Link
            key={article.slug}
            to={`/blog/${article.slug}`}
            className="block bg-[#111111] border border-white/8 rounded-lg p-5 hover:border-[#c8a96e]/40 transition-all group"
          >
            <span className="text-[#c8a96e] text-xs font-bold tracking-[0.15em] uppercase block mb-2">
              {article.category}
            </span>
            <span className="text-white text-sm font-semibold leading-snug group-hover:text-[#c8a96e] transition-colors">
              {article.title}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
